import React from 'react';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import translate from '../../other/translate.json';
import BackspaceIcon from '@material-ui/icons/Backspace';

export default function AppListTagArray(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru'

  let { arrayTag, setArrayTag, clearArrayTags, delArrayTag } = props

  return (
    <Grid item container
      direction="row"
      justify="flex-start"
      alignItems="center"
      style={{ /* height: 55, */ paddingTop: 12, paddingBottom: 24 }}
    >
      <Grid component="ul" className={classes.root}>
        {
          arrayTag
            ?
            arrayTag.map((data) => {
              return (
                <li key={data.key}>
                  <Chip
                    size="small"
                    deleteIcon={<CloseIcon />}
                    onDelete={setArrayTag(data)}
                    onClick={() => console.log('')}
                    label={data.label}
                    classes={{ root: classes.chip, deletable: classes.deletable }}
                  />
                </li>
              );
            })
            :
            ''
        }
        {
          arrayTag && arrayTag.length > 0
            ?
            <li key={'ClearAll'}>
              <Chip
                size="small"
                deleteIcon={<CloseIcon />}
                onClick={() => props.clearChips()}
                avatar={<BackspaceIcon style={{ height: '12px', fill: 'white' }} />}
                label={translate.Words[`ClearAllTags_${language}`]}
                classes={{ root: classes.chipClearAll, clickable: classes.chipClearAll, deletable: classes.deletable }}
              />
            </li>
            :
            null
        }
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },

  chip: {
    margin: theme.spacing(0.5),
    backgroundColor: '#FFF',
    color: '#8987A2',
    boxShadow: '2px 2px 4px rgba(68, 113, 209, 0.08)'
  },

  chipClearAll: {
    margin: theme.spacing(0.5),
    backgroundColor: '#3C3C56',
    color: '#FFFFFF',
    boxShadow: '2px 2px 4px rgba(68, 113, 209, 0.08)',

    '&:hover': {
      backgroundColor: '#3C3C56',
      color: '#FFFFFF',
    },

    '&:focus': {
      backgroundColor: '#3C3C56',
      color: '#FFFFFF',
    }
  },

  deletable: {
    margin: theme.spacing(0.5),
    backgroundColor: '#FFF',
    color: '#8987A2',
    boxShadow: '2px 2px 4px rgba(68, 113, 209, 0.08)',

    '&:hover': {
      background: '#FFFFFF',
    },

    '&:focus': {
      background: '#FFFFFF',
    }
  },
}));